import axios from 'axios';

const instance = axios.create({});

/**
 * @type {import('axios').AxiosInstance}
 */
const axiosInstance = {
  // export all axios default properties
  ...instance,
};

export default axiosInstance;
